<div class="col full-height layout-column">

  <!--Panel Skeleton, shown while routes are being fetched-->
  <app-card-skeleton *ngIf="isLoadingRoutes" class="flex" [rows]="8"></app-card-skeleton>

  <cdk-virtual-scroll-viewport *ngIf="!isLoadingRoutes && !!routes?.length"
                               class="flex"
                               autosize
                               (scroll)="onScroll($event)">


    <app-visit-plan-routes-panel-list-item *cdkVirtualFor="let route of routes; trackBy: trackById"
                                           cdkDropList
                                           [id]="route.id"
                                           [cdkDropListConnectedTo]="connectedPanelIds"
                                           (cdkDropListDropped)="onDrop(route, $event)"
                                           [route]="route"
                                           [isSelected]="selectedKeys[route.id]"
                                           [settings]="settings"
                                           [canSelect]="true"
                                           [canDrilldown]="true"
                                           [itemElementSize]="itemElementSize"
                                           [isShowActionMenu]="true"
                                           [agentColorMap]="agentColorMap"
                                           (onToggle)="onToggleSelectedRoute(route.id, $event)"
                                           (onToggleVisible)="onToggleVisibleRoute(route.id, $event)"
                                           (onSelect)="onSelect.emit(route)"
                                           (onLockRouteChange)="onLockRouteChange.emit($event)"
                                           (onChangeRouteResource)="onChangeRouteResource.emit($event)"
                                           (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                           (onDrillDown)="onDrillDown.emit(route)"
                                           (onRoutePanelContextMenu)="onRoutePanelContextMenu.emit($event)">

    </app-visit-plan-routes-panel-list-item>

  </cdk-virtual-scroll-viewport>


  <div *ngIf="!isLoadingRoutes && !routes?.length"
       class="flex layout-row layout-align-center-center fade-element-in-only overflow-auto">
    <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                     text="No Routes Found">

    </app-empty-state>
  </div>

  <!-- Custom drop animations -->
  <div *ngFor="let anim of dropAnimations"
       class="custom-drop-animation"
       [ngClass]="{'multiple-items': anim.isMultiple}"
       [style.left.px]="anim.x"
       [style.top.px]="anim.y">

    <!-- Single item animation - looks like activity item -->
    <div *ngIf="!anim.isMultiple" class="activity-item-preview">
      <div class="activity-icon">
      </div>
      <div class="activity-content">
        <div class="activity-title">{{ anim.text }}</div>
        <div class="activity-subtitle">Drop complete</div>
      </div>
    </div>

    <!-- Multiple items animation - looks like the blue drag preview -->
    <div *ngIf="anim.isMultiple" class="multiple-items-preview">
      <span>{{ anim.count }} Jobs Added</span>
    </div>
  </div>

</div>

